<template>
  <page-wrapper ref="pageEl">
    <div class="dialog-bg" @click.self="onConfirm(false)">
      <div class="dialog-box">
        <div class="title">
          ข้อมูลใบกำกับภาษีที่แสดงหน้าแอป
        </div>
        <div class="row">
          <div class="col-md-5">
            <div class="add-user-tax-invoice">
              <sc-button size="sm" variant="warning" @click="addTaxInvoice">
                + เพิ่มที่อยู่
              </sc-button>
            </div>
            <div
              v-for="addressTaxInvoice in listTaxInvoices"
              class="list-tax-invoice"
            >
              <div class="mb-7">
                <input
                  v-model="defaultTaxInvoiceId"
                  :checked="isCheckedTaxInvoiceId"
                  :value="addressTaxInvoice.taxInvoiceId"
                  name="selectedTaxInvoice"
                  type="radio"
                  value="true"
                  @click="selectAddressToInvoice(addressTaxInvoice)"
                />
                <span></span>
                &nbsp; &nbsp;
                <p>{{ addressTaxInvoice.name }}</p>
                <div class="right">
                  <a
                    class="edit"
                    href="#"
                    @click="deleteTaxInvoice(addressTaxInvoice)"
                  >
                    ลบ
                  </a>
                </div>
                <div class="right">
                  <a
                    class="edit"
                    href="#"
                    @click="editTaxInvoice(addressTaxInvoice)"
                  >
                    แก้ไข
                  </a>
                </div>
                <div
                  v-if="addressTaxInvoice.defaultTaxInvoice"
                  class="right edit subTitle"
                >
                  (ค่าตั้งต้น)
                </div>
              </div>
              <div>
                {{ addressTaxInvoice.addressLine1 }}
                {{ addressTaxInvoice.addressLine2 }}
              </div>
            </div>
          </div>
          <div v-if="this.isShowEdit" class="col-md-7 edit-tax-invoice">
            <div class="choice">
              <input
                v-model="from.type"
                name="type"
                type="radio"
                value="INDIVIDUAL"
                @click="removeBranchNo"
              />
              &nbsp; บุคคลธรรมดา &nbsp;&nbsp;
              <input
                v-model="from.type"
                name="type"
                type="radio"
                value="CORPORATE"
              />
              &nbsp; นิติบุคคล
              <div class="choose-default">
                <sc-button
                  size="sm"
                  variant="warning"
                  @click="setDefaultTaxInvoice(from.taxInvoiceId)"
                >
                  ตั้งเป็นค่าเริ่มต้น
                </sc-button>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 input-address">
                <div class="leave-line">
                  ชื่อออกใบกำกับภาษี
                  <input v-model="from.name" class="form-control" type="text" />
                </div>
                <div class="leave-line">
                  เลขสาขา (สำหรับนิติบุคคล)
                  <input
                    v-model="from.branchNo"
                    :disabled="from.type === 'INDIVIDUAL'"
                    class="form-control"
                    type="text"
                  />
                </div>
                <div class="leave-line">
                  บ้านเลขที่
                  <input
                    v-model="from.houseNo"
                    class="form-control"
                    type="text"
                  />
                </div>
                <div class="leave-line">
                  รหัสไปรษณีย์
                  <input
                    v-model="from.zipCode"
                    class="form-control"
                    type="text"
                  />
                </div>
                <div class="leave-line">
                  เขต/อำเภอ
                  <input
                    v-model="from.amphur"
                    class="form-control"
                    type="text"
                  />
                </div>
              </div>
              <div class="col-md-6 input-address">
                <div class="leave-line">
                  เลขประจำตัวผู้เสียภาษีอากร
                  <input
                    v-model="from.taxId"
                    class="form-control"
                    type="text"
                  />
                </div>
                <div class="leave-line">
                  Email
                  <input
                    v-model="from.email"
                    class="form-control"
                    type="text"
                  />
                </div>
                <div class="leave-line">
                  หมู่บ้าน ซอย ถนน อาคาร
                  <input
                    v-model="from.streetAddress"
                    class="form-control"
                    type="text"
                  />
                </div>
                <div class="leave-line">
                  จังหวัด
                  <input
                    v-model="from.province"
                    class="form-control"
                    type="text"
                  />
                </div>
                <div class="leave-line">
                  แขวง/ตำบล
                  <input
                    v-model="from.tumbon"
                    class="form-control"
                    type="text"
                  />
                  <input v-model="from.taxInvoiceId" type="hidden" />
                </div>
                <div class="row">
                  <div class="col-md-5">
                    <sc-button
                      class="form-control"
                      size="sm"
                      @click="cancelEditTaxInvoice"
                    >
                      ยกเลิก
                    </sc-button>
                  </div>
                  <div class="col-md-5">
                    <sc-button
                      class="form-control"
                      size="sm"
                      @click="submitTaxInvoice"
                    >
                      บันทึก
                    </sc-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      v-model="isShowRecurringDialog"
      :showClose="false"
      :visible="isShowRecurringDialog"
      width="30%"
      @close="cancelRecurringChangeTaxInvoiceDialog"
    >
      <div>
        <input
          v-model="isChangeRecurringTaxAddressEveryMonth"
          :value="true"
          name="taxInvoiceAddressEveryMonth"
          type="radio"
        />

        <p>เปลี่ยนสำหรับรอบบิลถัดไปทุกครั้ง</p>
      </div>
      <div>
        <input
          v-model="isChangeRecurringTaxAddressEveryMonth"
          :value="false"
          name="taxInvoiceAddressEveryMonth"
          type="radio"
        />
        <p>เปลี่ยนสำหรับรอบบิลถัดไป 1 ครั้ง</p>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <sc-button
            variant="primary"
            @click="handleClickTaxInvoiceEveryMonthButton"
          >
            บันทึก
          </sc-button>
        </span>
      </template>
    </el-dialog>
  </page-wrapper>
</template>

<script>
import { baanRueJaiClient } from "@/dependencies";
import ScButton from "@/lib/components/ScButton";
import PageWrapper from "@/lib/components/PageWrapper";
import { Dialog } from "element-ui";

export default {
  components: {
    ScButton,
    PageWrapper,
    "el-dialog": Dialog
  },
  props: ["isHTML", "value", "homeId", "selectedTaxInvoice", "isSentReceipt"],
  data() {
    const from = {
      name: null,
      branchNo: null,
      houseNo: null,
      zipCode: null,
      amphur: null,
      streetAddress: null,
      province: null,
      tumbon: null,
      taxInvoiceId: null,
      type: null,
      defaultTaxInvoice: false,
      isHomeAddress: false
    };
    return {
      from,
      addressUserTaxInvoices: null,
      isShowEdit: false,
      defaultTaxInvoiceId: null,
      previousTaxInvoiceId: null,
      isShowRecurringDialog: null,
      isChangeRecurringTaxAddressEveryMonth: true,
      selectedAddressTaxInvoice: null
    };
  },
  computed: {
    listTaxInvoices() {
      return this.addressUserTaxInvoices;
    }
  },
  created() {
    this.setup();
  },
  methods: {
    async setup() {
      this.addressUserTaxInvoices = await this.setupData();
    },
    onConfirm(action) {
      this.$emit("confirm", action);
    },
    async setupData() {
      const listUserTaxInvoices = await this.fetchData();

      return listUserTaxInvoices.map(taxInvoice => {
        const taxInvoiceId = taxInvoice.tax_invoice_id;
        const name = taxInvoice.name;
        const houseNo = taxInvoice.house_no;
        const streetAddress = taxInvoice.street_address;
        const tumbonName = taxInvoice.tumbon;
        const amphurName = taxInvoice.amphur;
        const province = taxInvoice.province;
        const zipCode = taxInvoice.zip_code;
        const email = taxInvoice.email;
        const taxId = taxInvoice.tax_id;
        const type = taxInvoice.type;
        const branchNo = taxInvoice.branch_no;
        const defaultTaxInvoice = taxInvoice.default_tax_invoice;
        const isHomeAddress = taxInvoice.is_home_address;
        const userId = taxInvoice.user_id;
        const homeId = taxInvoice.home_id;
        const tumbon = province === "กรุงเทพมหานคร" ? "แขวง" : "ตำบล";
        const amphur = province === "กรุงเทพมหานคร" ? "เขต" : "อำเภอ";

        const addressLine1 = [
          houseNo,
          streetAddress,
          `${tumbon}${tumbonName}`,
          `${amphur}${amphurName}`
        ].join(" ");

        const addressLine2 = [province, zipCode].join(" ");

        const selectedTaxInvoice =
          this.selectedTaxInvoice &&
          this.selectedTaxInvoice.id === taxInvoice.tax_invoice_id;

        if (selectedTaxInvoice) {
          this.defaultTaxInvoiceId = taxInvoiceId;
        }

        return {
          taxInvoiceId,
          name,
          addressLine1,
          addressLine2,
          houseNo,
          streetAddress,
          tumbonName,
          amphurName,
          province,
          zipCode,
          email,
          taxId,
          type,
          branchNo,
          defaultTaxInvoice,
          isHomeAddress,
          userId,
          homeId,
          selectedTaxInvoice
        };
      });
    },
    async fetchData() {
      const userId = this.value;

      const response = await baanRueJaiClient.admin.subscriptions.subscribers.getUserTaxInvoices(
        userId
      );

      return response.data.result;
    },
    editTaxInvoice(addressTaxInvoice) {
      this.from = {
        taxInvoiceId: addressTaxInvoice.taxInvoiceId,
        name: addressTaxInvoice.name,
        branchNo: addressTaxInvoice.branchNo,
        houseNo: addressTaxInvoice.houseNo,
        zipCode: addressTaxInvoice.zipCode,
        amphur: addressTaxInvoice.amphurName,
        taxId: addressTaxInvoice.taxId,
        email: addressTaxInvoice.email,
        streetAddress: addressTaxInvoice.streetAddress,
        province: addressTaxInvoice.province,
        tumbon: addressTaxInvoice.tumbonName,
        type: addressTaxInvoice.type,
        defaultTaxInvoice: addressTaxInvoice.defaultTaxInvoice
      };
      this.isShowEdit = true;
      this.$refs.pageEl.$el.querySelector(".page-content").scrollTop = 0;
    },
    cancelEditTaxInvoice() {
      this.clearTaxInvoice();
      this.isShowEdit = false;
    },
    addTaxInvoice() {
      this.clearTaxInvoice();
      this.isShowEdit = true;
    },
    async submitTaxInvoice() {
      if (!this.from.type) {
        alert("กรุณาเลือกประเภทบุคคล");
        return;
      }

      if (!this.from.name) {
        alert("กรุณากรอกชื่อ");
        return;
      }

      if (!this.from.taxId) {
        alert("กรุณากรอกเลขประจำตัวผู้เสียภาษีอากร");
        return;
      }

      if (this.from.type === "CORPORATE" && !this.from.branchNo) {
        alert("กรุณากรอกเลขสาขา (สำหรับนิติบุคคล)");
        return;
      }

      if (
        !this.from.houseNo ||
        !this.from.zipCode ||
        !this.from.amphur ||
        !this.from.streetAddress ||
        !this.from.province ||
        !this.from.tumbon
      ) {
        alert("กรุณากรอกที่อยู่ให้ครบ");
        return;
      }

      this.from.userId = this.value;
      this.from.homeId = this.homeId;
      const taxInvoiceData = this.from;

      if (taxInvoiceData.taxInvoiceId) {
        await baanRueJaiClient.admin.subscriptions.subscribers.putUpdateUserTaxInvoices(
          taxInvoiceData
        );
      } else {
        await baanRueJaiClient.admin.subscriptions.subscribers.postAddUserTaxInvoice(
          taxInvoiceData
        );
      }
      this.setup();
      this.isShowEdit = false;
    },
    clearTaxInvoice() {
      this.from = {
        taxInvoiceId: null,
        name: null,
        branchNo: null,
        houseNo: null,
        zipCode: null,
        amphur: null,
        taxId: null,
        email: null,
        streetAddress: null,
        province: null,
        tumbon: null,
        type: null
      };
    },
    async deleteTaxInvoice(taxInvoice) {
      if (!confirm("ยืนยันการลบรายการ")) {
        return;
      }

      const params = {
        taxInvoiceId: taxInvoice.taxInvoiceId,
        userId: taxInvoice.userId,
        defaultTaxInvoice: taxInvoice.defaultTaxInvoice
      };

      await baanRueJaiClient.admin.subscriptions.subscribers.deleteUserTaxInvoices(
        params
      );

      if (taxInvoice.defaultTaxInvoice) {
        this.$emit("addressTaxInvoice");
      }
      this.setup();
      this.isShowEdit = false;
    },
    async selectAddressDefault(selectTaxInvoice) {
      if (!confirm("ยืนยันการเปลี่ยนที่อยู่")) {
        this.addressUserTaxInvoices = null;

        return this.setup();
      }

      const params = {
        userId: this.value,
        taxInvoiceId: selectTaxInvoice.taxInvoiceId
      };

      await baanRueJaiClient.admin.subscriptions.subscribers.putDefaultUserTaxInvoices(
        params
      );
    },
    removeBranchNo() {
      this.from.branchNo = null;
    },
    async setDefaultTaxInvoice(taxInvoiceId) {
      const selectTaxInvoice = this.listTaxInvoices.find(
        taxInvoice => taxInvoice.taxInvoiceId === taxInvoiceId
      );

      await this.selectAddressDefault(selectTaxInvoice);

      this.addressUserTaxInvoices = this.listTaxInvoices.map(taxInvoice => {
        return {
          ...taxInvoice,
          defaultTaxInvoice: taxInvoice.taxInvoiceId === taxInvoiceId
        };
      });
    },
    isCheckedTaxInvoiceId() {
      return this.addressTaxInvoice.taxInvoiceId === this.defaultTaxInvoiceId;
    },
    async selectAddressToInvoice(addressTaxInvoice) {
      this.selectedAddressTaxInvoice = addressTaxInvoice;
      if (this.isSentReceipt) {
        this.previousTaxInvoiceId = this.defaultTaxInvoiceId;
        this.isShowRecurringDialog = true;
      } else {
        this.handleClickTaxInvoiceEveryMonthButton();
      }
    },
    cancelRecurringChangeTaxInvoiceDialog() {
      this.isShowRecurringDialog = false;
      if (this.previousTaxInvoiceId) {
        this.defaultTaxInvoiceId = this.previousTaxInvoiceId;
      }
    },
    handleClickTaxInvoiceEveryMonthButton() {
      this.previousTaxInvoiceId = null;
      this.isShowRecurringDialog = false;
      this.isShowEdit = false;
      this.$emit(
        "selectTaxInvoice",
        this.selectedAddressTaxInvoice.taxInvoiceId,
        this.isChangeRecurringTaxAddressEveryMonth
      );

      const addressInvoice = {
        line1: this.selectedAddressTaxInvoice.addressLine1,
        line2: this.selectedAddressTaxInvoice.addressLine2
      };

      this.$emit("addressTaxInvoice", addressInvoice);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.dialog-box {
  top: 50%;
  left: 50%;
  width: 1164px;
  height: 684px;
  position: absolute;
  background: #fcfcfc 0% 0% no-repeat padding-box;
  border-radius: 24px;
  padding: 0;
  transform: translate(-50%, -50%);
  overflow-x: auto;
}

.title {
  font-size: 20px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: -0.1px;
  text-align: left;
  color: #000;
  background: #d4d4d4;
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  padding: 24px 40px;
}

.subTitle {
  font-size: 14px;
  color: #999898;
}

.list-tax-invoice {
  padding: 15px 25px 15px 50px;
  border-bottom: $border;
  border-right: $border;
}

.add-user-tax-invoice {
  padding-top: 30px;
  padding-right: 30px;
  padding-bottom: 10px;
  padding-left: 50px;
}

.edit-tax-invoice {
  padding-left: 0;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
}

.select-input {
  color: $black;
}

input[type="radio"] {
  border: 0;
  height: 1em;
  width: auto;
  display: inline;
}

p {
  display: inline;
  font-size: 20px;
  font-weight: 200;
  text-indent: 30px;
}

.choice {
  padding-top: 70px;
  padding-left: 30px;
}

.input-address {
  padding-left: 50px;
  padding-right: 25px;
  padding-top: 30px;
  height: 125px;
}

.leave-line {
  padding-bottom: 20px;
}

.right {
  text-align: right;
  float: right;
  padding-right: 20px;
}

.text-align {
  text-align: right;
}

.choose-default {
  display: inline;
  padding-left: 30px;
}

.dialog-footer button:first-child {
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/features/subscriptions/modules/subscribers/components/ListTaxInvoices.vue